import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DocumentApi } from '../../../apis/Documents/DocumentApi.ts';
import { Document } from '../Document.ts';
import { patientStore } from '../../../Store/Store.ts';

export function useDeleteDocumentMutations() {
    const queryClient = useQueryClient();
    const patientId = patientStore.patientId;

    return useMutation({
        mutationKey: [QueryKeys.documents, QueryKeys.document],
        mutationFn: async ({ id }: { id: string }) => {
            return DocumentApi.deleteDocument(id);
        },
        onSuccess: (_, { id }: { id: string }) => {
            queryClient.setQueryData<Document[]>(
                [QueryKeys.documents, patientId],
                (prev) => prev?.filter((document) => document.id.toString() !== id.toString()) ?? [],
            );

            queryClient.invalidateQueries({ queryKey: [QueryKeys.document, id.toString()] });
        },
    });
}
